/**
 * 排出事業者
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'
import * as types from '../../../mutation-types/admin-types'
import {ADMIN_EMISSION_RESET_CONDITION, ADMIN_EMISSION_RESET_PAGINATION} from "../../../mutation-types/admin-types";

const API_PATH = `${httpConst.ADMIN_ENDPOINT}/masters/emissions`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      subscriber_number: null,
      from_subscriber_number: null,
      to_subscriber_number: null,
      edi_usage_key: null,
      name: null,
      requester_name: null,
      jwnet_price_plan: null,
    },
  }
}

const emission = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     * 排出事業者一覧取得
     * @param dispatch
     * @param commit
     * @param state
     * @param name
     * @param subscriber_number
     * @param from_subscriber_number
     * @param to_subscriber_number
     * @param edi_usage_key
     * @param requester_name
     * @param jwnet_price_plan
     * @param page
     * @param format
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { name, subscriber_number, from_subscriber_number, to_subscriber_number, edi_usage_key, requester_name, jwnet_price_plan, page, format }) {
      let api_path
      if (format === 'csv') {
        api_path = `${API_PATH}.csv`
      } else {
        api_path = `${API_PATH}`
      }
      dispatch('saveCondition', { name: name, subscriber_number: subscriber_number, from_subscriber_number: from_subscriber_number, to_subscriber_number: to_subscriber_number, edi_usage_key: edi_usage_key, requester_name: requester_name, jwnet_price_plan: jwnet_price_plan })
      const params = {
        name: state.condition.name,
        subscriber_number: state.condition.subscriber_number,
        from_subscriber_number: state.condition.from_subscriber_number,
        to_subscriber_number: state.condition.to_subscriber_number,
        edi_usage_key: state.condition.edi_usage_key,
        requester_name: state.condition.requester_name,
        jwnet_price_plan: state.condition.jwnet_price_plan,
        page: page
      }
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          if (format !== 'csv') {
            let content = data.content
            commit(types.ADMIN_EMISSION, { content })
            resolve(data.content)
          } else {
            resolve(data)
          }
        })
      })
    },
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    new () {
      const api_path = `${API_PATH}/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    edit ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          commit
          resolve(data.content)
        })
      })
    },
    update ({ commit },{ id, params }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    destroy ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
    warningCheck ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/warning_check`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content.warning)
        })
      })
    },
    saveCondition ({ commit, state }, { name, subscriber_number, from_subscriber_number, to_subscriber_number,edi_usage_key,requester_name, jwnet_price_plan }) {
      const _name = (name !== undefined) ? name : state.condition.name
      const _subscriber_number = (subscriber_number !== undefined) ? subscriber_number : state.condition.subscriber_number
      const _from_subscriber_number = (from_subscriber_number !== undefined) ? from_subscriber_number : state.condition.from_subscriber_number
      const _to_subscriber_number = (to_subscriber_number !== undefined) ? to_subscriber_number : state.condition.to_subscriber_number
      const _edi_usage_key = (edi_usage_key !== undefined) ? edi_usage_key : state.condition.edi_usage_key
      const _requester_name = (requester_name !== undefined) ? requester_name : state.condition.requester_name
      const _jwnet_price_plan = (jwnet_price_plan !== undefined) ? jwnet_price_plan : state.condition.jwnet_price_plan
      const params = { name: _name, subscriber_number: _subscriber_number, from_subscriber_number: _from_subscriber_number, to_subscriber_number: _to_subscriber_number, edi_usage_key: _edi_usage_key, requester_name: _requester_name, jwnet_price_plan: _jwnet_price_plan }
      commit(types.ADMIN_EMISSION_CONDITION, { params })
    },
    resetState ({ commit }) {
      commit(types.ADMIN_EMISSION_RESET_CONDITION)
    },
    resetPagination ({ commit }) {
      commit(types.ADMIN_EMISSION_RESET_PAGINATION)
    },
  },
  mutations: {
    [types.ADMIN_EMISSION_RESET_PAGINATION] (state) {
      Object.assign(state.pagination, getDefaultState().pagination)
    },
    [types.ADMIN_EMISSION_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    [types.ADMIN_EMISSION] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.ADMIN_EMISSION_CONDITION] (state, { params }) {
      state.condition.name = params.name
      state.condition.subscriber_number = params.subscriber_number
      state.condition.from_subscriber_number = params.from_subscriber_number
      state.condition.to_subscriber_number = params.to_subscriber_number
      state.condition.edi_usage_key = params.edi_usage_key
      state.condition.requester_name = params.requester_name
      state.condition.jwnet_price_plan = params.jwnet_price_plan
    }
  },

}

export default emission
